import { Route, Navigate } from 'react-router-dom';
import ImportUsersPage from './pages/ImportUsersPage';
import NotificationsPage from './pages/NotificationsPage';
import AdminSubscriptionsPage from './pages/AdminSubscriptionsPage';
import AdminPaymentsPage from './pages/AdminPaymentsPage';
import PaymentMethodSettingsPage from './pages/PaymentMethodSettingsPage';
import AdminUsersPage from './pages/AdminUsersPage';
import AdminEmailsPage from './pages/AdminEmailsPage';
import AdminEmailRequestsPage from './pages/AdminEmailRequestsPage';
import AdminAuditsPage from './pages/AdminAuditsPage';
import AdminWaHealthPage from './pages/AdminWaHealthPage';
import AdminFeatureAdoptionPage from './pages/AdminFeatureAdoptionPage';
import TenantModulesPage from './pages/TenantModulesPage';
import AdminReferralsPage from './pages/AdminReferralsPage';
import AdminNegocioPage from './pages/AdminNegocioPage';
import { usePestanaActiva } from '../../components/common/PestanasModulo';
import { PAGOS_TAB_IDS, CORREOS_TAB_IDS } from './pestanas';

// Reorden del admin (24-oct-2026): Pagos y Correos son UNA pantalla con pestañas; las rutas viejas redirigen.
// Analíticas Globales desapareció: sus paneles reales (crecimiento, totales) viven en el Inicio (#crecimiento) y su
// «Estado del Sistema» (Elasticsearch/Firebase «funcionando») estaba cableado en duro desde la época Firebase.
// Notificaciones sigue viva por URL pero fuera del menú (0 creadas desde junio).
const PagosPage = () => (usePestanaActiva(PAGOS_TAB_IDS) === 'ajustes' ? <PaymentMethodSettingsPage /> : <AdminPaymentsPage />);
const CorreosPage = () => (usePestanaActiva(CORREOS_TAB_IDS) === 'solicitudes' ? <AdminEmailRequestsPage /> : <AdminEmailsPage />);

export const AdminRoutes = [
  <Route key="admin-tenant-modules" path="/dashboard/admin/tenants/:id/modules" element={<TenantModulesPage />} />,
  <Route key="admin-negocio" path="/dashboard/admin/negocios/:id" element={<AdminNegocioPage />} />,
  <Route key="admin-wa-health" path="/dashboard/admin/wa-health" element={<AdminWaHealthPage />} />,
  <Route key="admin-adopcion" path="/dashboard/admin/adopcion" element={<AdminFeatureAdoptionPage />} />,
  <Route key="admin-emails" path="/dashboard/admin/emails" element={<CorreosPage />} />,
  <Route key="admin-email-requests" path="/dashboard/admin/email-requests" element={<Navigate to="/dashboard/admin/emails?tab=solicitudes" replace />} />,
  <Route key="admin-audits" path="/dashboard/admin/audits" element={<AdminAuditsPage />} />,
  <Route key="admin-import" path="/dashboard/admin/import" element={<ImportUsersPage />} />,
  <Route key="admin-notifications" path="/dashboard/admin/notifications" element={<NotificationsPage />} />,
  <Route key="admin-subscriptions" path="/dashboard/admin/subscriptions" element={<AdminSubscriptionsPage />} />,
  <Route key="admin-users" path="/dashboard/admin/users" element={<AdminUsersPage />} />,
  <Route key="admin-payments" path="/dashboard/admin/payments" element={<PagosPage />} />,
  <Route key="admin-referrals" path="/dashboard/admin/referrals" element={<AdminReferralsPage />} />,
  <Route key="admin-payment-methods" path="/dashboard/admin/payment-methods" element={<Navigate to="/dashboard/admin/payments?tab=ajustes" replace />} />,
  <Route key="admin-analytics" path="/dashboard/admin/analytics" element={<Navigate to="/dashboard#crecimiento" replace />} />,
];
